import {
  AddUpdateTaskParams,
  convertTask,
  Task,
  TasksResponse,
} from '@nextforce/api'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useServer } from 'app/server/context'
import { RecurrentTaskUpdateType } from 'tasks/types'
import keys from './shared/keys'

interface Variables {
  id: string
  update_type?: RecurrentTaskUpdateType
  exception_id?: string
  data: AddUpdateTaskParams
}

export function useUpdateTask() {
  const { server } = useServer()
  const client = useQueryClient()

  return useMutation({
    mutationFn: updateTask,
    onSuccess: async () => {
      // Invalidate relevant queries
      await client.invalidateQueries({ queryKey: keys.all })
    },
  })

  async function updateTask({
    id,
    update_type,
    exception_id,
    data,
  }: Variables): Promise<Task> {
    const url = `v2/tasks/custom/${id}`
    const params = new URLSearchParams()

    if (update_type) {
      params.append('update_type', update_type)
    }
    if (exception_id) {
      params.append('exception_id', exception_id)
    }

    const queryString = params.toString()
    const fullUrl = queryString ? `${url}?${queryString}` : url

    const response = await server.put<TasksResponse.Task>(
      fullUrl,
      {
        summary: data.summary,
        description: data.description,
        due_date: data.dueDate,
        new_due_date: data.newDueDate,
        photo_required: data.photoRequired,
        recurring: data.recurring,
        frequency: data.frequency,
        interval: data.interval,
        monthly_on: data.monthlyOn,
        by_day: data.byDay,
        until: data.until,
      },
      'user',
      'json'
    )
    return convertTask(response)
  }
}
